import { useAppService } from "@fero/hooks";
import { base64ToPdfBlob, downloadBlob } from "@fero/utils";
import { useMutation } from "@tanstack/react-query";
import type { NominatedPurchaserId } from "adl-gen/ferovinum/app/db";

export const useGetNominatedPurchaserOutstandingBalanceSummaryPdfQuery = () => {
  const service = useAppService();
  return useMutation(
    (nominatedPurchaserId: NominatedPurchaserId) =>
      service.getNominatedPurchaserOutstandingBalanceSummaryPDF({
        nominatedPurchaserId,
      }),
    {
      onSuccess: (data) => {
        const blob = base64ToPdfBlob(data);
        downloadBlob(blob, "Outstanding Balance Summary.pdf");
      },
    },
  );
};
